import React, { useEffect, useState } from 'react';
import { get, isEmpty, isString } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import * as regularExamActions from '../../../actions/regularExamActions';
import Grid from '@material-ui/core/Grid';
import './styles.scss';
import TabPanel from './components/TabPanel';
import PageHeading from '../../../components/PageHeading';
import NoData from '../../../components/NoData';
import FilterIcon from '../../../assets/filter-icon.svg';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Skeleton } from '@material-ui/lab';

export default function RegularExamCalendar() {
  // State
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [checked, setChecked] = useState('All');
  const [isFetching, setIsFetching] = useState(true);

  // Redux

  const dispatch = useDispatch();
  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const examCalendarData = useSelector(state =>
    get(state, 'regularExamReducer.data', {})
  );
  const ErrorMessage = useSelector(state =>
    get(state, 'regularExamReducer.errorMessage', '')
  );

  useEffect(() => {
    setIsFetching(true);
    regularExamActions.examCalendarList(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  useEffect(() => {
    setIsFetching(true);
    regularExamActions.examCalendarList(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, [loginData]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = val => {
    setAnchorEl(null);
    if (isString(val)) setChecked(val);
  };

  const compareDate = mydate => {
    let q = new Date();
    let m = q.getMonth();
    let d = q.getDate();
    let y = q.getFullYear();

    let date = new Date(y, m, d);
    let xdate = new Date(mydate);
    const isSameDay = (a, b) => {
      return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
      );
    };
    if (isSameDay(date, xdate) === true) {
      return 'Today';
    } else if (date < xdate) {
      return 'Upcoming';
    } else {
      return 'Past';
    }
  };
  const populateRegularExam = () => {
    const list = [];
    let whenLoading = [1, 1, 1, 1];
    (isFetching
      ? whenLoading
      : checked === 'All'
      ? examCalendarData
      : examCalendarData.filter(el => {
          return compareDate(el.TestDate) === checked;
        })
    ).map((data, index) => {
      if (isFetching) {
        list.push(
          <Grid item xs={12} key={index}>
            <div className="exam-layout">
              <Skeleton className="date-box" width={'20%'} />

              <div className="exam-title">
                <Skeleton
                  className="time"
                  width={'20%'}
                  height={'30px'}
                  style={{ backgroundColor: '#e4e4e4' }}
                />
              </div>

              <div className="exam-details">
                <TabPanel
                  MarkingScheme={<Skeleton height={'40px'} />}
                  Syllabus={<Skeleton height={'40px'} />}
                  TestCentre={<Skeleton height={'40px'} />}
                  isFetching={isFetching}
                />
              </div>
            </div>
          </Grid>
        );
      } else {
        list.push(
          <Grid item xs={12} key={index} id={`#${data.TestID}`}>
            <div className="exam-layout">
              <div
                className="date-box"
                style={{
                  backgroundColor:
                    compareDate(data.TestDate) === 'Today'
                      ? '#ef7f27'
                      : compareDate(data.TestDate) === 'Past'
                      ? '#e4e4e4'
                      : compareDate(data.TestDate) === 'Upcoming'
                      ? '#2a2a2a'
                      : '',
                  color:
                    compareDate(data.TestDate) === 'Today'
                      ? '#fff'
                      : compareDate(data.TestDate) === 'Past'
                      ? '#2a2a2a'
                      : compareDate(data.TestDate) === 'Upcoming'
                      ? '#fff'
                      : ''
                }}
              >
                <span className="date">{data.TestDate}</span>
                <span className="day">({data.TestDay.substr(0, 3)})</span>
              </div>
              <div className="exam-title">
                <h3>{data.TestName}</h3>
                <div
                  className="time"
                  style={{
                    backgroundColor:
                      compareDate(data.TestDate) === 'Today'
                        ? '#ef7f27'
                        : compareDate(data.TestDate) === 'Past'
                        ? '#e4e4e4'
                        : compareDate(data.TestDate) === 'Upcoming'
                        ? '#2a2a2a'
                        : '',
                    color:
                      compareDate(data.TestDate) === 'Today'
                        ? '#fff'
                        : compareDate(data.TestDate) === 'Past'
                        ? '#2a2a2a'
                        : compareDate(data.TestDate) === 'Upcoming'
                        ? '#fff'
                        : ''
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                  >
                    <path
                      id="time2"
                      d="M10,3.5a7,7,0,1,0,7,7A7,7,0,0,0,10,3.5ZM9.943,16.168A5.654,5.654,0,1,1,15.6,10.515,5.654,5.654,0,0,1,9.943,16.168Zm1.634-5.329h-1.6V8.13a.533.533,0,1,0-1.066,0v3.242a.532.532,0,0,0,.533.533h2.137a.533.533,0,1,0,0-1.065Z"
                      transform="translate(-3 -3.5)"
                      fill="currentColor"
                    />
                  </svg>

                  {data.TimeDetail}
                </div>
              </div>
              <div className="exam-details">
                <TabPanel
                  MarkingScheme={data.MarkingScheme}
                  Syllabus={data.Syllabus}
                  TestCentre={data.TestCentre}
                />
              </div>
            </div>
          </Grid>
        );
      }
    });

    return <Grid container>{list}</Grid>;
  };

  return (
    <React.Fragment>
      <div className="flex-row flex-space-between">
        <PageHeading titlePrimary="Regular Exam" titleSecondary="Calendar" />

        {isFetching ? (
          <Skeleton width={'10%'} height={'30px'} />
        ) : !isEmpty(examCalendarData) ? (
          <div className="paper-box">
            <Button
              variant="outlined"
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <img src={FilterIcon} className="icon" />
              {checked}
              <span className="caret ml-10" />
            </Button>
          </div>
        ) : null}
      </div>

      {!isEmpty(examCalendarData) || isFetching ? (
        <React.Fragment>
          {!isEmpty(populateRegularExam().props.children) || isFetching ? (
            populateRegularExam()
          ) : (
            <NoData
              message={`As of now there is No ${checked} Exam scheduled for your batch.`}
            />
          )}
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={() => handleClose('All')}>All</MenuItem>
            <MenuItem onClick={() => handleClose('Past')}>Past</MenuItem>
            <MenuItem onClick={() => handleClose('Today')}>Today</MenuItem>
            <MenuItem onClick={() => handleClose('Upcoming')}>
              Upcoming
            </MenuItem>
          </Menu>
        </React.Fragment>
      ) : (
        <NoData
          message={
            ErrorMessage ||
            'As of now no Exam scheduled is available for your batch. Please come back later.'
          }
        />
      )}
    </React.Fragment>
  );
}
